import { render, staticRenderFns } from "./lawPhase.vue?vue&type=template&id=13fe953b&scoped=true&"
import script from "./lawPhase.vue?vue&type=script&lang=js&"
export * from "./lawPhase.vue?vue&type=script&lang=js&"
import style0 from "./lawPhase.vue?vue&type=style&index=0&id=13fe953b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fe953b",
  null
  
)

export default component.exports